module.exports = __webpack_public_path__ + "static/media/FJ.4ca5cdf7.svg";